import type { Group, Measure } from './api'

/** The page's view in the URL; defaults (Lead time · Manufacturers · 12 months · page 1) stay out. */
export type QuotedVsActualSearch = {
  compare?: Exclude<Measure, 'lead_time'>
  group?: Exclude<Group, 'manufacturer'>
  months?: number
  q?: string
  page?: number
  /** The row whose drawer is open. */
  row?: string
}

export const MONTH_OPTIONS = [3, 6, 12, 24] as const
const DEFAULT_MONTHS = 12

export type QuotedVsActualView = {
  measure: Measure
  group: Group
  months: number
  search: string
  page: number
  openKey: string | null
}

export function validateQuotedVsActualSearch(search: Record<string, unknown>): QuotedVsActualSearch {
  const result: QuotedVsActualSearch = {}
  if (search.compare === 'net' || search.compare === 'freight') result.compare = search.compare
  if (search.group === 'category' || search.group === 'product') result.group = search.group
  const months = Number(search.months)
  if (months !== DEFAULT_MONTHS && (MONTH_OPTIONS as readonly number[]).includes(months)) result.months = months
  if (typeof search.q === 'string' && search.q) result.q = search.q.slice(0, 200)
  const page = Number(search.page)
  if (Number.isInteger(page) && page > 1) result.page = page
  if (typeof search.row === 'string' && search.row) result.row = search.row.slice(0, 200)
  return result
}

export function viewFromSearch(search: QuotedVsActualSearch): QuotedVsActualView {
  return {
    measure: search.compare ?? 'lead_time',
    group: search.group ?? 'manufacturer',
    months: search.months ?? DEFAULT_MONTHS,
    search: search.q ?? '',
    page: search.page ?? 1,
    openKey: search.row ?? null,
  }
}

export function searchFromView(view: QuotedVsActualView): QuotedVsActualSearch {
  return validateQuotedVsActualSearch({
    compare: view.measure,
    group: view.group,
    months: view.months,
    q: view.search,
    page: view.page,
    row: view.openKey ?? undefined,
  })
}
